import { Button, StyledForm, Text } from '@/components/common';
import { TextField } from '@/components/form';
import { sendPasswordToResetEmail } from '@/libs/firebase';
import { ModalHeader } from '@/styles/common';
import { Box } from '@mui/material';
import { Formik, FormikProps } from 'formik';
import React, { useRef, useState } from 'react';
import * as yup from 'yup';

import { useAppDispatch } from '@/redux/hooks';
import { ModalRenderer } from '@/utils/modalUtils';
import { EmailSchema } from '@/utils/validation';
import { useTranslation } from 'react-i18next';
import SendCodePassModal from '../SendCodePassModal';
import { ErrorMessage } from './styled';
const schema = yup.object().shape({
  email: EmailSchema,
});

const SendResetModal: React.FC<any> = ({ closeModal }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const formikRef = useRef<FormikProps<{ email: string }>>(null);
  const [error, setError] = useState<string | null>('');

  const onClose = () => {
    closeModal();
  };
  const onSubmit = async (values: any) => {
    try {
      dispatch({ type: 'SHOW_LOADING' });
      await sendPasswordToResetEmail(values.email);
      setTimeout(() => closeModal(), 10);
      ModalRenderer.open({
        component: SendCodePassModal,
        theme: 'white',
        inMobile: 'bottom',
        props: {
          email: values.email,
        },
      });
    } catch (error: any) {
      if (error.code === 'auth/user-not-found') {
        setError(t('EMAIL_NOT_RECOGNISED'));
      } else {
        setError(t('ERROR_MESSAGE_SOMETHING_WENT_WRONG'));
      }
    } finally {
      dispatch({ type: 'HIDE_LOADING' });
    }
  };
  return (
    <>
      <ModalHeader color="primary" variant="title" size="26" sx={{ lineHeight: '28px' }}>
        <img
          style={{ width: '32px', height: '32px', cursor: 'pointer' }}
          src="/images/icon/icon_back.svg"
          onClick={onClose}
          alt=""
        />
        {t('FORGOT_PASSWORD')}
      </ModalHeader>
      <Text color="secondary" variant="content" size="16" style={{ marginBottom: '24px' }}>
        {t('FORGOT_PASSWORD_CONTENT')}
      </Text>
      <Formik initialValues={{ email: '' }} onSubmit={onSubmit} innerRef={formikRef} validationSchema={schema}>
        {({ errors, values, isValid }) => (
          <StyledForm>
            <TextField
              type="email"
              name="email"
              config={{
                variant: 'standard',
                label: t('EMAIL_ADDRESS'),
                themeColor: 'white',
                onClick: () => setError(null),
                InputProps: {
                  'data-testid': 'test_email',
                },
              }}
            />
            {error ? <ErrorMessage>{error}</ErrorMessage> : null}
            <Box sx={{ mt: 5 }}>
              <Button
                fullWidth
                variant="contained"
                color="dark"
                type="submit"
                data-testid="test_btn_continue"
                disabled={!(isValid && !error && values.email)}
              >
                {t('SEND_RESET_LINK')}
              </Button>
            </Box>
          </StyledForm>
        )}
      </Formik>
    </>
  );
};

export default SendResetModal;
